// store.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isLoading: false
    },
    mutations: {
        setLoading(state, status) {
            state.isLoading = status;
        }
    },
    actions: {
        showLoading({ commit }) {
            commit('setLoading', true);
        },
        hideLoading({ commit }) {
            commit('setLoading', false);
        }
    },
    getters: {
        isLoading: state => state.isLoading
    }
});
